<div
  class="flex min-h-[54px] min-w-[350px] items-center gap-4 rounded-lg p-6 text-white"
  [ngClass]="{
    'bg-info-100': type === 'info',
    'bg-success-100': type === 'success',
    'bg-warning-100': type === 'warning',
    'bg-error-100': type === 'error',
    'bg-neutral-300': type === 'blocked' || type === 'locked',
    'max-w-[450px]': !extraWidth,
    'max-w-[650px]': extraWidth,
    'animate-wiggle': wiggle,
  }"
>
  @if (icon) {
    <rl-icon [matIcon]="icon" [matIconOutlined]="false"></rl-icon>
  }
  <div class="flex-1 text-sm" [innerHTML]="message | safe: 'html'"></div>
  <rl-icon class="pointer-events-auto mb-1 cursor-pointer" matIcon="close" (click)="close($event)"></rl-icon>
</div>
